import { Preferences } from '@capacitor/preferences'
import { platform } from './platform'
import { safeStorage } from '../lib/safe-storage'

/**
 * Storage adapter for the Supabase auth client.
 *
 * The web branch must never throw: this backs session persistence, so a
 * `localStorage` access that raises (blocked site data, private mode) used to
 * surface as an app that never finished booting.
 */
export const capacitorStorage = {
  async getItem (key: string): Promise<string | null> {
    if (platform.isNative()) {
      try {
        const { value } = await Preferences.get({ key })
        return value
      } catch (err) {
        console.warn('[storage] native read failed:', err)
        return null
      }
    }
    return safeStorage.get(key)
  },

  async setItem (key: string, value: string): Promise<void> {
    if (platform.isNative()) {
      try {
        await Preferences.set({ key, value })
      } catch (err) {
        console.warn('[storage] native write failed:', err)
      }
      return
    }
    safeStorage.set(key, value)
  },

  async removeItem (key: string): Promise<void> {
    if (platform.isNative()) {
      try {
        await Preferences.remove({ key })
      } catch (err) {
        console.warn('[storage] native remove failed:', err)
      }
      return
    }
    safeStorage.remove(key)
  }
}
